<template>
    <textarea
      class="textarea"
      :class="{
        textarea_error: error,
        [`textarea_resize-${resize}`]: resize
      }"
      v-model="modelValue"
    />
</template>

<script>
export default {
  props: {
    value: String,
    error: Boolean,
    resize: String,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.textarea {
    width: 100%;
    background: var(--tertiary-bg);
    border: 1px solid var(--tertiary-accent);
    border-radius: 2px;
    padding: 6px;
    font-size: 14px;
    font-family: "IBM Plex Sans", sans-serif;
    color: var(--text-primary);

    &_error {
      border-color: var(--text-error);
      background-color: var(--bg-error);
    }

    &_resize-vertical {
        resize: vertical;
    }

    &_resize-horizontal {
        resize: horizontal;
    }

    &_resize-both {
        resize: both;
    }

    &_resize-none {
      resize: none;
    }

    @include notebook {
      font-size: 16px;
    }

    &::placeholder {
        font-family: "IBM Plex Sans", sans-serif;
        color: var(--text-primary);
    }
}
</style>
